import React, { useMemo } from 'react';
import { Text } from 'react-native-paper';
import getGlobalStyles from '../globalStyles';
import { useThemeSettings } from '../ThemeProvider';
import {
  Dimensions,
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
  FlatList,
} from 'react-native';
import { CustomIcon } from './CustomIcon';
import { useModalStore } from '../store/modalStore';
import { useNavigation } from '@react-navigation/native';
import { ROUTES } from '../shared/constants/routes';
import { useCollectionStore } from '../store/collectionStore';
import { useArticlesData } from '../providers/ArticlesDataProvider';
import { useAudioContext } from '../providers/AudioProvider';
import { useActiveArticle } from '../features/news-feed/hooks/useActiveArticle';
import { getImageUri } from '../shared/helpers/utils';

const SCREEN_HEIGHT = Dimensions.get('window').height;

export default function AudioListModal() {
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);

  const navigation = useNavigation();
  const { selectedCollection } = useCollectionStore();
  const { clearModal } = useModalStore()
  const { articles } = useArticlesData();
  const { activeArticle, setActiveArticleId } = useActiveArticle();
  const { isPlaying, isLoading, togglePlayback } = useAudioContext();

  const renderItem = ({ item }: { item: any }) => {
    const isCurrentAudio = activeArticle?.id === item.id;
    const isCurrentAudioPlaying = isCurrentAudio && (isPlaying || isLoading);
    return (
      <TouchableOpacity
        activeOpacity={0.85}
        onPress={async (e) => {
              e.stopPropagation();

              if (isCurrentAudioPlaying) {
                await togglePlayback("pause");
                return;
              }

              setActiveArticleId(item.id);
              await togglePlayback("play");
            }}
      >
        <View style={[styles.wrapper, { borderColor: theme.colors.primary, backgroundColor: theme.colors.surfaceBg }]}>
          {/* LEFT IMAGE */}
          <Image source={getImageUri(item.image!)} style={styles.thumb} />

          {/* TITLE */}
          <Text numberOfLines={2} style={[styles.title, {color:theme.colors.textPrimary}]}>
            {item.title}
          </Text>

          {/* PLAY/PAUSE BUTTON */}
          <View
            style={[
              styles.menuBtn,
              { borderColor: theme?.colors?.primary },
            ]}
          >
            <CustomIcon
              icon={isCurrentAudioPlaying ? 'pause' : 'play'}
              size={18}
              color={theme?.colors?.primary}
            />
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <View style={[styles.container]}>
      <FlatList
        data={articles}
        keyExtractor={(item) => item.id}
        renderItem={renderItem}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={[gStyles.fullWidthWithMargin]}
        style={[{ maxHeight: SCREEN_HEIGHT * 0.7 }]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },

  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 14,
    borderWidth: 1.5,
    marginBottom: 12,
    gap: 10,
    overflow: 'hidden',
  },

  thumb: {
    width: 44,
    height: 60,
  },

  title: {
    flex: 1,
    fontSize: 14,
    lineHeight: 18,
    fontWeight: '500',
  },

  menuBtn: {
    width: 34,
    height: 34,
    borderRadius: 17,
    borderWidth: 1.5,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
});